import React, {useState, useEffect} from 'react';
import {Container} from '../../global';
import GallerySlider from './GallerySlider';
import ReactHtmlParser from 'react-html-parser';
import {
  LazyLoadImage,
  trackWindowScroll,
} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import {
  GalleryGrid,
  Figure,
  GalleryPic,
  GalleryWrapper,
  PhotoSign,
} from './styles';

const Gallery = ({
  color,
  images,
  columnsNumber,
  isFlex,
  colorSign,
  hoverColor,
  isImgFit,
  maxWidth,
  style,
  scrollPosition,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.innerWidth < 768 && setIsMobile(true);
    }
  }, []);
  return (
    <GalleryWrapper color={color}>
      {selectedIndex !== null && (
        <GallerySlider
          images={images}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
        />
      )}
      <Container padding={!isMobile}>
        <GalleryGrid
          columnsNumber={columnsNumber}
          isFlex={isFlex}
          style={{...style, maxWidth: `${maxWidth}%`, margin: '0 auto'}}>
          {images.map(({src, sign, width}, index) => (
            <div
              style={{
                height: sign ? 'calc(100% - 0.65rem - 1rem)' : '100%',
                width: !isMobile && width,
              }}>
              <Figure
                hoverColor={hoverColor}
                onClick={() => setSelectedIndex(index)}>
                <LazyLoadImage
                  effect="blur"
                  alt={sign}
                  key={src}
                  scrollPosition={scrollPosition}
                  src={src}
                  className={isImgFit ? 'special-image-cover' : 'special-image'}
                />
              </Figure>
              {sign && (
                <PhotoSign style={{color: colorSign}}>
                  {ReactHtmlParser(sign)}
                </PhotoSign>
              )}
            </div>
          ))}
        </GalleryGrid>
      </Container>
    </GalleryWrapper>
  );
};

export default trackWindowScroll(Gallery);
